export default __webpack_public_path__ + "static/media/03_Retour.15cb3293.mp3";